// Note Console — Premium product catalog. All prices in INR.
// Realistic beige/linen/gold aesthetic (Pexels imagery).

const IMG = {
  hero: "https://images.pexels.com/photos/6683341/pexels-photo-6683341.jpeg?auto=compress&cs=tinysrgb&w=1600",
  planner_closed: "https://images.pexels.com/photos/5712463/pexels-photo-5712463.jpeg?auto=compress&cs=tinysrgb&w=1400",
  planner_flatlay: "https://images.pexels.com/photos/5717413/pexels-photo-5717413.jpeg?auto=compress&cs=tinysrgb&w=1400",
  planner_open: "https://images.pexels.com/photos/5717418/pexels-photo-5717418.jpeg?auto=compress&cs=tinysrgb&w=1400",
  planner_page: "https://images.pexels.com/photos/5717452/pexels-photo-5717452.jpeg?auto=compress&cs=tinysrgb&w=1400",
  gold_pen: "https://images.pexels.com/photos/1226398/pexels-photo-1226398.jpeg?auto=compress&cs=tinysrgb&w=1000",
  desk_scene: "https://images.pexels.com/photos/6373305/pexels-photo-6373305.jpeg?auto=compress&cs=tinysrgb&w=1400",
  dried_flowers: "https://images.pexels.com/photos/6620574/pexels-photo-6620574.jpeg?auto=compress&cs=tinysrgb&w=1400",
  neutral: "https://images.pexels.com/photos/28536456/pexels-photo-28536456.jpeg?auto=compress&cs=tinysrgb&w=1400",
  linen_texture: "https://images.pexels.com/photos/6567607/pexels-photo-6567607.jpeg?auto=compress&cs=tinysrgb&w=1400",
  stickers: "https://images.pexels.com/photos/5717452/pexels-photo-5717452.jpeg?auto=compress&cs=tinysrgb&w=1000",
  pouch: "https://images.pexels.com/photos/6567607/pexels-photo-6567607.jpeg?auto=compress&cs=tinysrgb&w=1000",
  journal: "https://images.pexels.com/photos/5717418/pexels-photo-5717418.jpeg?auto=compress&cs=tinysrgb&w=1000",
  founder: "https://images.pexels.com/photos/6373305/pexels-photo-6373305.jpeg?auto=compress&cs=tinysrgb&w=800",
  weekly: "https://images.pexels.com/photos/5717413/pexels-photo-5717413.jpeg?auto=compress&cs=tinysrgb&w=1200",
};

export const IMAGES = IMG;

const IMG_ROTATION = [
  [IMG.planner_closed, IMG.planner_flatlay, IMG.planner_open],
  [IMG.planner_flatlay, IMG.planner_open, IMG.planner_page],
  [IMG.weekly, IMG.planner_open, IMG.planner_flatlay],
  [IMG.planner_open, IMG.planner_page, IMG.planner_closed],
  [IMG.planner_page, IMG.planner_flatlay, IMG.desk_scene],
  [IMG.journal, IMG.planner_open, IMG.planner_flatlay],
  [IMG.planner_closed, IMG.desk_scene, IMG.linen_texture],
];
let __imgIdx = 0;
const nextImgs = () => {
  const set = IMG_ROTATION[__imgIdx % IMG_ROTATION.length];
  __imgIdx += 1;
  return set;
};

const p = (o) => ({
  format: ["A5"], cover: ["Soft Paperback"], colors: ["Sand"],
  features: [], plannerType: "undated", category: "planners",
  images: nextImgs(),
  bullets: [], inside: [], specs: {}, rating: 4.8, reviews: 120,
  ...o,
  priceINR: 499,
  compareAtINR: undefined,
});

// ---- 18 PLANNERS + JOURNALS ----
const PLANNERS = [
  p({
    id: "life-os-planner", slug: "life-os-planner",
    name: "The Life OS Planner",
    tagline: "For the driven. By design.",
    plannerType: "undated",
    format: ["B5"], cover: ["Soft Paperback", "Hard Binding"],
    personalization: ["Without Name", "With Name on Cover"],
    pageColors: ["B/W", "Coloured"],
    defaultOptions: {
      cover: "Soft Paperback",
      personalization: "Without Name",
      pageColor: "B/W",
      color: "Cocoa",
    },
    variantPricing: {
      pageColorPrices: {
        "B/W": 349,
        Coloured: 549,
      },
      personalizationAddOns: {
        "With Name on Cover": 100,
        "Without Name": 0,
      },
      coverAddOns: {
        "Soft Paperback": 0,
        "Hard Binding": 250,
      },
    },
    colors: ["Cocoa", "Sand", "Cream", "Stone"],
    images: [
      "/product/life-os-cocoa-desk.jpg",
      "/product/life-os-cocoa-standing.jpg",
    ],
    features: ["undated", "goal-setting", "habit-tracking"],
    priceINR: 349, compareAtINR: 999,
    rating: 4.9, reviews: 167, badge: "BESTSELLER", stockQty: 27,
    description: "A premium planner for the driven. The Life OS Planner helps you clarify your vision, plan with intention, and take daily action toward your highest goals.",
    bullets: [
      "200+ premium Structured pages for planning, tracking, and reflection",
      "Six core sections to organize every area of life",
      "Undated format so you can start anytime",
    ],
    inside: ["Vision & Goals", "Monthly Overview", "Weekly Plan", "Daily Dashboard", "Habit Tracker", "Track & Reflect"],
    specs: { Pages: "216", Paper: "80gsm ivory", Size: "Standard B5", "Pages Colour": "B/W / Coloured", Cover: "Soft Paperback / Hard Binding", Binding: "Soft Paperback or Hard Binding" },
  }),
  p({
    id: "daily-focus-planner", slug: "daily-focus-planner",
    name: "Daily Focus Planner",
    plannerType: "daily",
    format: ["A5"], cover: ["Hard Binding"], colors: ["Cream", "Sand"],
    features: ["dated", "goal-setting"],
    priceINR: 999, rating: 4.8, reviews: 612,
    description: "Structured daily pages for deep-work days and focused execution.",
    bullets: ["90 daily pages", "Priority + timeblock layout", "Ribbon marker"],
    inside: ["Daily Dashboard", "Time Blocks", "Reflection"],
    specs: { Pages: "180", Paper: "100gsm", Size: "A5" },
  }),
  p({
    id: "weekly-planner", slug: "weekly-planner",
    name: "Weekly Planner",
    plannerType: "weekly",
    format: ["A5"], cover: ["Soft Paperback"], colors: ["Cream"],
    features: ["undated"],
    priceINR: 999, rating: 4.7, reviews: 341,
    images: [IMG.weekly, IMG.planner_open, IMG.planner_page],
    description: "Undated weekly spreads with priorities and reflection prompts.",
    bullets: ["52 weekly spreads", "Priority panel", "Weekly review"],
    inside: ["Weekly Plan", "Reflection"],
    specs: { Pages: "160", Paper: "100gsm", Size: "A5" },
  }),
  p({
    id: "mba-planner", slug: "mba-planner",
    name: "MBA Planner", plannerType: "mba",
    format: ["B5"], cover: ["Hard Binding"], colors: ["Cocoa"],
    features: ["dated", "goal-setting"],
    priceINR: 999, rating: 4.9, reviews: 208,
    description: "Academic planner engineered for MBA candidates and graduate students.",
    bullets: ["Semester overviews", "Case & study logs", "Career tracker"],
    inside: ["Semester Plan", "Case Tracker", "Career Sprint"],
    specs: { Pages: "240", Paper: "120gsm", Size: "B5" },
  }),
  p({
    id: "academic-planner", slug: "academic-planner",
    name: "Academic Planner", plannerType: "academic",
    format: ["A5"], cover: ["Hard Binding"], colors: ["Sand", "Stone"],
    features: ["dated"],
    priceINR: 999, rating: 4.7, reviews: 187,
    description: "Aug–Aug academic calendar for students and teachers.",
  }),
  p({
    id: "undated-a5-planner", slug: "undated-a5-planner",
    name: "Undated A5 Planner",
    plannerType: "undated", format: ["A5"], cover: ["Hard Binding"], colors: ["Cream", "Sand"],
    features: ["undated"],
    priceINR: 999, rating: 4.6, reviews: 156,
    description: "The classic undated planner in a compact A5.",
  }),
  p({
    id: "undated-b5-planner", slug: "undated-b5-planner",
    name: "Undated B5 Planner",
    plannerType: "undated", format: ["B5"], cover: ["Hard Binding"], colors: ["Stone", "Cocoa"],
    features: ["undated"],
    priceINR: 999, rating: 4.7, reviews: 142,
    description: "A larger canvas for detailed planners and visual thinkers.",
  }),
  p({
    id: "vegan-leather-planner", slug: "vegan-leather-planner",
    name: "Hard Binding Planner",
    plannerType: "undated", format: ["A5"], cover: ["Hard Binding"], colors: ["Cocoa", "Cream"],
    features: ["undated", "goal-setting"],
    priceINR: 999, rating: 4.9, reviews: 96,
    description: "Premium vegan leather cover, refillable insert.",
  }),
  p({
    id: "executive-planner", slug: "executive-planner",
    name: "Executive Planner",
    plannerType: "daily", format: ["B5"], cover: ["Hard Binding"], colors: ["Cocoa"],
    features: ["dated", "goal-setting"],
    priceINR: 999, rating: 4.9, reviews: 78,
    description: "For CEOs and founders — timeblocked days with strategy pages.",
  }),
  p({
    id: "minimal-planner", slug: "minimal-planner",
    name: "Minimal Planner", plannerType: "undated",
    format: ["A5"], cover: ["Soft Paperback"], colors: ["Cream"],
    features: ["undated"],
    priceINR: 999, rating: 4.6, reviews: 210,
    description: "Just the essentials — clean grids, generous whitespace.",
  }),
  p({
    id: "focus-journal", slug: "focus-journal",
    name: "Focus Journal", category: "planners", plannerType: "undated",
    format: ["A5"], cover: ["Hard Binding"], colors: ["Cream", "Sand"],
    features: ["undated", "habit-tracking"],
    priceINR: 999, rating: 4.8, reviews: 840,
    images: [IMG.journal, IMG.planner_flatlay, IMG.planner_open],
    description: "A slim daily journal for morning intention and evening reflection.",
    bullets: ["144 pages", "Morning + evening prompts", "Gratitude log"],
    inside: ["Morning Pages", "Evening Reflection"],
    specs: { Pages: "144", Paper: "100gsm", Size: "A5" },
  }),
  p({
    id: "gratitude-journal", slug: "gratitude-journal",
    name: "Gratitude Journal", plannerType: "undated",
    format: ["A5"], cover: ["Hard Binding"], colors: ["Sand"],
    features: ["undated"],
    priceINR: 999, rating: 4.8, reviews: 620,
    images: [IMG.journal, IMG.planner_open],
    description: "Five minutes a day for a more grateful, present mind.",
  }),
  p({
    id: "reflection-journal", slug: "reflection-journal",
    name: "Reflection Journal", plannerType: "undated",
    format: ["A5"], cover: ["Hard Binding"], colors: ["Stone"],
    features: ["undated"],
    priceINR: 999, rating: 4.7, reviews: 412,
    images: [IMG.journal, IMG.planner_page],
    description: "Weekly, monthly, and quarterly reflection prompts.",
  }),
  p({
    id: "creative-journal", slug: "creative-journal",
    name: "Creative Journal", plannerType: "undated",
    format: ["B5"], cover: ["Hard Binding"], colors: ["Cream"],
    features: ["undated"],
    priceINR: 999, rating: 4.7, reviews: 288,
    images: [IMG.journal, IMG.planner_open],
    description: "Blank + dotted spreads for sketchers and lettering artists.",
  }),
  p({
    id: "habit-journal", slug: "habit-journal",
    name: "Habit Tracker Journal", plannerType: "undated",
    format: ["A5"], cover: ["Soft Paperback"], colors: ["Cream"],
    features: ["undated", "habit-tracking"],
    priceINR: 999, rating: 4.8, reviews: 512,
    images: [IMG.planner_page, IMG.planner_open],
    description: "Track 12 habits over 12 weeks. Repeatable format.",
  }),
  p({
    id: "goal-journal", slug: "goal-journal",
    name: "Goal Setting Journal", plannerType: "undated",
    format: ["A5"], cover: ["Hard Binding"], colors: ["Sand"],
    features: ["undated", "goal-setting"],
    priceINR: 999, rating: 4.7, reviews: 236,
    images: [IMG.planner_open, IMG.planner_page],
    description: "12-week goal cycles with weekly milestones and reviews.",
  }),
  p({
    id: "vision-journal", slug: "vision-journal",
    name: "Vision Journal", plannerType: "undated",
    format: ["A5"], cover: ["Hard Binding"], colors: ["Cream"],
    features: ["undated", "goal-setting"],
    priceINR: 999, rating: 4.9, reviews: 168,
    images: [IMG.planner_flatlay, IMG.planner_closed],
    description: "Map your 1-year, 5-year, and life vision with clarity.",
  }),
  p({
    id: "ritual-journal", slug: "ritual-journal",
    name: "Morning Ritual Journal", plannerType: "daily",
    format: ["A5"], cover: ["Hard Binding"], colors: ["Sand"],
    features: ["dated"],
    priceINR: 999, rating: 4.7, reviews: 194,
    images: [IMG.journal, IMG.planner_open],
    description: "6 minutes every morning to set your mind, body, and day.",
  }),
];

// ---- 6 PLANNER BUNDLES ----
const BUNDLES = [
  p({
    id: "productivity-bundle", slug: "productivity-bundle",
    name: "Productivity Bundle", category: "bundles", plannerType: "undated",
    format: ["A5"], cover: ["Hard Binding"], colors: ["Sand"],
    features: ["goal-setting", "habit-tracking"],
    priceINR: 999, compareAtINR: 999, rating: 5.0, reviews: 156, badge: "BUNDLE",
    images: [IMG.planner_closed, IMG.gold_pen, IMG.stickers],
    description: "The Life OS Planner + Gold Pen + Sticker set — the complete kit.",
    bullets: ["Life OS Planner", "Premium Gold Pen", "Neutral Sticker Set", "Save ₹1,500"],
    specs: { Includes: "3 items", Saving: "₹1,500" },
  }),
  p({
    id: "starter-kit", slug: "starter-kit",
    name: "Starter Kit", category: "bundles",
    format: ["A5"], cover: ["Hard Binding"], colors: ["Cream"],
    features: [], priceINR: 999, compareAtINR: 999, rating: 4.8, reviews: 92, badge: "BUNDLE",
    images: [IMG.journal, IMG.gold_pen],
    description: "Focus Journal + Premium Gold Pen — for planning beginners.",
  }),
  p({
    id: "professional-bundle", slug: "professional-bundle",
    name: "Professional Bundle", category: "bundles",
    format: ["A5"], cover: ["Hard Binding"], colors: ["Cocoa"],
    features: ["goal-setting"],
    priceINR: 999, compareAtINR: 999, rating: 4.9, reviews: 64, badge: "BUNDLE",
    images: [IMG.planner_closed, IMG.pouch, IMG.gold_pen],
    description: "Executive Planner + Leather Pouch + Gold Pen.",
  }),
  p({
    id: "study-bundle", slug: "study-bundle",
    name: "Study Bundle", category: "bundles", plannerType: "academic",
    format: ["A5"], cover: ["Hard Binding"], colors: ["Stone"],
    features: ["dated"],
    priceINR: 999, compareAtINR: 999, rating: 4.7, reviews: 74, badge: "BUNDLE",
    images: [IMG.planner_open, IMG.stickers, IMG.gold_pen],
    description: "Academic Planner + Sticker Set + Gel Pen.",
  }),
  p({
    id: "creator-bundle", slug: "creator-bundle",
    name: "Creator Bundle", category: "bundles",
    format: ["B5"], cover: ["Hard Binding"], colors: ["Cream"],
    features: [],
    priceINR: 999, compareAtINR: 999, rating: 4.8, reviews: 58, badge: "BUNDLE",
    images: [IMG.journal, IMG.planner_open],
    description: "Creative Journal + Washi Tape + Gel Pen Set.",
  }),
  p({
    id: "executive-bundle", slug: "executive-bundle",
    name: "Executive Bundle", category: "bundles",
    format: ["B5"], cover: ["Hard Binding"], colors: ["Cocoa"],
    features: ["goal-setting"],
    priceINR: 999, compareAtINR: 999, rating: 4.9, reviews: 42, badge: "BUNDLE",
    images: [IMG.planner_closed, IMG.gold_pen, IMG.pouch],
    description: "Executive Planner + Premium Pouch + Gold Pen.",
  }),
];

// ---- 12 ACCESSORIES ----
const ACCESSORIES = [
  p({
    id: "gold-pen", slug: "gold-pen",
    name: "Premium Gold Pen", category: "accessories", plannerType: "n/a",
    format: ["N/A"], cover: ["N/A"], colors: ["Gold"], features: [],
    priceINR: 999, rating: 4.8, reviews: 980, badge: "BESTSELLER",
    images: [IMG.gold_pen, IMG.desk_scene],
    description: "Weighted brass rollerball with a smooth 0.7mm black ink refill.",
    bullets: ["Weighted brass", "0.7mm black", "Refillable"],
    specs: { Material: "Brass", Ink: "0.7mm black" },
  }),
  p({
    id: "brass-rollerball", slug: "brass-rollerball",
    name: "Brass Rollerball", category: "accessories", plannerType: "n/a",
    format: ["N/A"], cover: ["N/A"], colors: ["Gold"], features: [],
    priceINR: 799, rating: 4.7, reviews: 542,
    images: [IMG.gold_pen, IMG.desk_scene],
    description: "Everyday brass rollerball. Grip texture, smooth flow.",
  }),
  p({
    id: "planner-stickers", slug: "planner-stickers",
    name: "Neutral Sticker Set", category: "accessories", plannerType: "n/a",
    format: ["N/A"], cover: ["N/A"], colors: ["Sand"], features: [],
    priceINR: 699, rating: 4.9, reviews: 420,
    images: [IMG.stickers, IMG.planner_flatlay],
    description: "3 sheets of matte neutral planner stickers with gold foil accents.",
  }),
  p({
    id: "planner-pouch", slug: "planner-pouch",
    name: "Canvas Planner Pouch", category: "accessories", plannerType: "n/a",
    format: ["N/A"], cover: ["N/A"], colors: ["Cream"], features: [],
    priceINR: 999, rating: 4.7, reviews: 265,
    images: [IMG.pouch, IMG.linen_texture],
    description: "Natural canvas pouch with brass zipper — fits your planner and pen.",
  }),
  p({
    id: "leather-bookmark", slug: "leather-bookmark",
    name: "Leather Bookmark Set", category: "accessories", plannerType: "n/a",
    format: ["N/A"], cover: ["N/A"], colors: ["Cocoa"], features: [],
    priceINR: 499, rating: 4.6, reviews: 148,
    images: [IMG.linen_texture, IMG.desk_scene],
    description: "Set of 3 vegan leather bookmarks with gold foil.",
  }),
  p({
    id: "washi-tape", slug: "washi-tape",
    name: "Washi Tape Set", category: "accessories", plannerType: "n/a",
    format: ["N/A"], cover: ["N/A"], colors: ["Sand"], features: [],
    priceINR: 549, rating: 4.7, reviews: 208,
    images: [IMG.stickers, IMG.planner_open],
    description: "5-roll neutral washi tape set. Matte finish.",
  }),
  p({
    id: "gel-pen-set", slug: "gel-pen-set",
    name: "Gel Pen Set", category: "accessories", plannerType: "n/a",
    format: ["N/A"], cover: ["N/A"], colors: ["Cream"], features: [],
    priceINR: 649, rating: 4.6, reviews: 172,
    images: [IMG.desk_scene, IMG.gold_pen],
    description: "6 muted-tone gel pens. 0.5mm.",
  }),
  p({
    id: "sticky-notes", slug: "sticky-notes",
    name: "Sticky Notes Pack", category: "accessories", plannerType: "n/a",
    format: ["N/A"], cover: ["N/A"], colors: ["Sand"], features: [],
    priceINR: 349, rating: 4.5, reviews: 96,
    images: [IMG.stickers, IMG.planner_page],
    description: "3-pack neutral sticky notes with kraft covers.",
  }),
  p({
    id: "index-tabs", slug: "index-tabs",
    name: "Index Tab Set", category: "accessories", plannerType: "n/a",
    format: ["N/A"], cover: ["N/A"], colors: ["Cream"], features: [],
    priceINR: 399, rating: 4.6, reviews: 68,
    images: [IMG.stickers, IMG.planner_flatlay],
    description: "48 pre-printed index tabs. Removable adhesive.",
  }),
  p({
    id: "pen-case", slug: "pen-case",
    name: "Vegan Leather Pen Case", category: "accessories", plannerType: "n/a",
    format: ["N/A"], cover: ["N/A"], colors: ["Cocoa"], features: [],
    priceINR: 899, rating: 4.7, reviews: 84,
    images: [IMG.pouch, IMG.desk_scene],
    description: "Slim pen case — holds up to 3 pens.",
  }),
  p({
    id: "desk-mat", slug: "desk-mat",
    name: "Vegan Leather Desk Mat", category: "accessories", plannerType: "n/a",
    format: ["N/A"], cover: ["N/A"], colors: ["Cream", "Cocoa"], features: [],
    priceINR: 999, rating: 4.8, reviews: 62,
    images: [IMG.desk_scene, IMG.linen_texture],
    description: "Large desk mat — soft base, elegant surface.",
  }),
  p({
    id: "notebook-stand", slug: "notebook-stand",
    name: "Walnut Notebook Stand", category: "accessories", plannerType: "n/a",
    format: ["N/A"], cover: ["N/A"], colors: ["Cocoa"], features: [],
    priceINR: 999, rating: 4.7, reviews: 46,
    images: [IMG.desk_scene, IMG.linen_texture],
    description: "Solid walnut stand — holds your planner at a comfortable angle.",
  }),
];

const REMOVED_SEED_PRODUCT_IDS = new Set([
  "academic-planner",
  "undated-a5-planner",
  "undated-b5-planner",
  "vegan-leather-planner",
  "executive-planner",
  "minimal-planner",
  "focus-journal",
  "gratitude-journal",
  "reflection-journal",
  "creative-journal",
  "habit-journal",
  "goal-journal",
  "vision-journal",
  "ritual-journal",
]);

export const PRODUCTS = PLANNERS.filter((product) => !REMOVED_SEED_PRODUCT_IDS.has(product.id));

export const LIFE_OS_VARIANT_PRICING = {
  pageColorPrices: {
    "B/W": 349,
    Coloured: 549,
  },
  personalizationAddOns: {
    "With Name on Cover": 100,
    "Without Name": 0,
  },
  coverAddOns: {
    "Soft Paperback": 0,
    "Hard Binding": 250,
  },
};

export const getProductVariantPrice = (product, opts = {}) => {
  if (!product) return 0;
  const pricing = product.variantPricing || (product.id === "life-os-planner" ? LIFE_OS_VARIANT_PRICING : null);
  if (!pricing) return product.priceINR || 0;

  const pageColor = opts.pageColor || product.defaultOptions?.pageColor || product.pageColors?.[0] || "B/W";
  const personalization = opts.personalization || product.defaultOptions?.personalization || product.personalization?.[0] || "Without Name";
  const cover = opts.cover || product.defaultOptions?.cover || product.cover?.[0] || "Soft Paperback";

  const pageColorPrice = pricing.pageColorPrices?.[pageColor] ?? product.priceINR ?? 0;
  const personalizationAddOn = pricing.personalizationAddOns?.[personalization] ?? 0;
  const coverAddOn = pricing.coverAddOns?.[cover] ?? 0;

  return Number(pageColorPrice) + Number(personalizationAddOn) + Number(coverAddOn);
};

export const PLANNER_PAGES = [
  { key: "cover", label: "Not Just A Planner", pages: 1, img: "/planner-pages/planner-page-01.jpg" },
  { key: "belongs", label: "This Planner Belongs To", pages: 1, img: "/planner-pages/planner-page-03.jpg" },
  { key: "vision", label: "My Big Vision", pages: 1, img: "/planner-pages/planner-page-06.jpg" },
  { key: "comeback", label: "My Comeback Plan", pages: 1, img: "/planner-pages/planner-page-12.jpg" },
  { key: "main-character", label: "Main Character Page", pages: 1, img: "/planner-pages/planner-page-13.jpg" },
  { key: "monthly", label: "Monthly Dashboard", pages: 12, img: "/planner-pages/planner-page-22.jpg" },
  { key: "weekly-dashboard", label: "Weekly Dashboard", pages: 1, img: "/planner-pages/planner-page-47.jpg" },
  { key: "daily-system", label: "Daily Dashboard System", pages: 90, img: "/planner-pages/planner-page-96.jpg" },
  { key: "trigger", label: "Trigger Tracker", pages: 1, img: "/planner-pages/planner-page-196.jpg" },
  { key: "spending", label: "Daily Spending Tracker", pages: 1, img: "/planner-pages/planner-page-199.jpg" },
  { key: "weekly-reset", label: "Weekly Reset", pages: 1, img: "/planner-pages/planner-page-213.jpg" },
  { key: "life-audit", label: "Life Audit", pages: 1, img: "/planner-pages/planner-page-215.jpg" },
];

export const REVIEWS = [
  { name: "Ananya S.", location: "Mumbai", rating: 5, title: "Changed how I plan.",
    body: "The Life OS Planner is the first planner I've stuck with beyond February. The paper is exquisite and the sections just make sense." },
  { name: "Rohan K.", location: "Bengaluru", rating: 5, title: "Genuinely premium.",
    body: "The cover finish, page quality, and overall structure feel premium. It feels like an object you keep for years, not a disposable notebook." },
  { name: "Priya M.", location: "Delhi", rating: 5, title: "The habit tracker alone is worth it.",
    body: "I've built a morning routine that's finally stuck. The reflection prompts are thoughtful without being preachy." },
  { name: "Vikram R.", location: "Pune", rating: 4, title: "Beautiful and functional.",
    body: "Wish it came in more colors, but the Sand cover is gorgeous. The MBA add-on section is a nice touch for grad students." },
];

// Premium "INR X,XXX" formatting like the reference screenshots
export const formatINR = (n) =>
  `INR ${new Intl.NumberFormat("en-IN", { maximumFractionDigits: 0 }).format(n)}`;

export const findProduct = (slugOrId) =>
  PRODUCTS.find((x) => x.slug === slugOrId || x.id === slugOrId);


